module.exports = __webpack_public_path__ + "assets/9426146d14ff8844ba6cd6ab5b9d7965.png";